<template>
    <div>
        <!-- Botón principal -->
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" text color="primary" @click="onButtonClick" class="d-flex align-center">
                    <span v-if="buttonText" style="margin-right: auto;">{{ buttonText }}</span>
                    <v-icon>{{ icon }}</v-icon>
                </v-btn>
            </template>
            <!-- Lista de acciones -->
            <v-list>
                <v-list-item v-for="(action, index) in actions" :key="index" @click="handleAction(action)"
                    class="action-item">
                    <v-list-item-avatar v-if="action.icon">
                        <v-icon>{{ action.icon }}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{ action.text }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: "Actions",
    props: {
        icon: {
            type: String,
            default: "expand_more",
        },
        buttonText: {
            type: String,
            default() {
                return this.$t('wkt.admin.em.header.action-menu');
            },
        },
        actions: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    methods: {
        onButtonClick() {
            this.$emit("button-click");
        },
        handleAction(action) {
            if (action.onClick && typeof action.onClick === "function") {
                action.onClick();
            }
            this.$emit("action-click", action);
        },
    },
};
</script>

<style scoped>
.action-item {
    cursor: pointer;
}
</style>